import {
  DialogTitle,
  DialogActions,
  Button,
  Checkbox,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function ConfigModal({
  open,
  onClose,
  headers,
  visibleColumns,
  setVisibleColumns,
}) {
  const handleToggleColumn = (header) => {
    if (visibleColumns.includes(header)) {
      setVisibleColumns(visibleColumns.filter((col) => col !== header));
    } else {
      setVisibleColumns([...visibleColumns, header]);
    }
  };

  return (
    <>
      <Box>
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 0,
            mb: 2,
          }}
        >
          Настройка колонок
          <DialogActions sx={{ p: 0, justifyContent: "start" }}>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </DialogActions>
        </DialogTitle>

        {headers.map((header, idx) => (
          <Box
            key={header}
            className={`border-bottom ${idx === 0 ? "border-top" : ""}`}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              py: 0.5,
            }}
          >
            <Typography variant="subtitle1">{header}</Typography>
            <Checkbox
              checked={visibleColumns.includes(header)}
              onChange={() => handleToggleColumn(header)}
            />
          </Box>
        ))}
      </Box>
    </>
  );
}
